import { Quill } from 'react-quill';

export const FONT_HEADERS = ['1', '2', '3', '4', false];

const Picker = Quill.import('ui/picker');

export default class SnazzyFontHeaderPicker extends Picker {
    buildItem(option) {
        const item = super.buildItem(option);
        if (option.value) {
            item.title = `Heading ${option.value}`;
        } else {
            item.title = 'Normal';
        }
        return item;
    }
}
